const typographyActionExpansion = {
  action: 'Acciones generadas ',
  accountable: 'Responsables: ',
  deadline: 'Fecha límite: ',
  noAccountable: 'Sin responsable',
  action: "Acción: ",
  problem: "Problema: ",
};

export default typographyActionExpansion;
